export default __webpack_public_path__ + "static/media/BQ-BO.bf3afb92.svg";